<template>
  <b-container>
    <b-row>
      <b-col
        v-if="payerValid"
        cols="12"
      >
        <div
          v-if="providerIntegrapay"
          class="section-card"
        >
          <card-display-integrapay-view-card />
        </div>
        <div
          v-if="providerStripeConnect"
          class="section-card"
        >
          <loading-spinner v-if="loadingStripeCards">
            Loading Stored payment Details
          </loading-spinner>
          <div class="stripe-payment-detials">
            <stripe-payments-storedcard-display
              :card-details="payer.token"
              size="lg"
              @loading="(val) => loadingStripeCards = val"
            >
              <div class="change-payment-details">
                <b-button
                  variant="primary"
                  @click="clearCardDetails"
                >
                  Change Payment Method
                </b-button>
              </div>
            </stripe-payments-storedcard-display>
          </div>
        </div>
        <div
          v-if="providerSquarePayments"
          class="section-card"
        >
          <loading-spinner v-if="loadingSquareCards">
            Loading Stored payment Details
          </loading-spinner>
          <div class="square-payment-detials">
            <square-payments-storedcard-display
              :account="account"
              :card-details="payer"
              size="lg"
              @loading="(val) => loadingStripeCards = val"
            >
              <div class="change-payment-details">
                <b-button
                  variant="primary"
                  @click="clearCardDetails"
                >
                  Change Payment Method
                </b-button>
              </div>
            </square-payments-storedcard-display>
          </div>
        </div>
      </b-col>

      <b-col v-if="!payerValid">
        <b-tabs class="somnambulist-enter-payment-method">
          <template v-for="(method, idx) in paymentMethods">
            <stored-card-entry-wrapper
              :key="idx"
              :method="method"
              @selected-card="payerUpdated"
            />
          </template>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import CardDisplayIntegrapayViewCard from './CardDisplayIntegrapayViewCard.vue'
import StoredCardEntryWrapper from './StoredCardEntryWrapper.vue'

export default {
  name: 'card-display',
  components: {
    'card-display-integrapay-view-card': CardDisplayIntegrapayViewCard,
    'stored-card-entry-wrapper': StoredCardEntryWrapper
  },
  data: function() {
    return {
      loadingStripeCards: false,
      loadingSquareCards: false,
      stripeCardDetails: {},
      squareCardDetails: {}
    }
  },
  computed: {
    ...mapState('somnambulistui', ['payer', 'payerValid']),
    ...mapGetters('somnambulistui', ['account']),
    userid: function() {
      if (Object.prototype.hasOwnProperty.call(this.$route.params, 'uid')) {
        return this.$route.params.user
      }
      else {
        return this.$store.getters['somnambulistui/initUid']
      }
    },
    paymentMethods: function() {
      return this.$store.getters[['ecommerce/storedCardPaymentMethods']]
    },
    providerIntegrapay: function() {
      return this.payer && (!Object.prototype.hasOwnProperty.call(this.payer, 'provider') || this.payer.provider === 'integrapay')
    },
    providerStripeConnect: function() {
      return this.payer && (Object.prototype.hasOwnProperty.call(this.payer, 'provider') && this.payer.provider === 'stripe_connect_payments')
    },
    providerSquarePayments: function() {
      return this.payer && (Object.prototype.hasOwnProperty.call(this.payer, 'provider') && this.payer.provider === 'square_payments')
    }
  },
  methods: {
    ...mapMutations('somnambulistui', ['SET_PAYER', 'SET_PAYER_VALID']),
    clearCardDetails: function() {
      this.SET_PAYER('')
      this.SET_PAYER_VALID(false)
    },
    payerUpdated: function(val) {
      this.$emit('update-payer', val)
    }
  }
}
</script>

<style lang="scss">

  .tabs.somnambulist-enter-payment-method .nav-item:only-child {
    display: none;
  }

  .stripe-payment-detials {
    .card-options {
      margin-top: auto;
      display: flex;
      justify-content: flex-end;
      align-self: flex-end;
    }
    .card-description {
      margin-bottom: 1.2rem;
    }
  }

</style>
